import React, { useState, useCallback } from 'react';
import { getAllUpcomingCaterings } from '../../../services/OrderService';
import CateringList from '../../components/Orders/CateringList';

const Catering = () => {
    const [cateringList, setCateringList] = useState();
    const sort = 3;
    const [pagination, setPagination] = useState()

    const getUpcomingCaterings = useCallback(() => {
        getAllUpcomingCaterings().then(res => {
            res.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
            setPagination(Array(Math.ceil(res.length / sort))
                .fill()
                .map((_, i) => i + 1));
            setCateringList(res);
        });
    }, []);
    return (
        <CateringList cateringList={cateringList}
            getUpcomingCaterings={getUpcomingCaterings}
            pagination={pagination}
            sort={sort}
        />
    );
}

export default Catering;
